import React from 'react'
import Breadcrumbs from '../Breadcrumbs'
import { Link } from "react-router-dom";
import Footer from '../Footer';

export default function Mareos() {
    return (
        <section>
            <div className='container'>
                <div style={{marginTop:'4rem'}}>
                    <Breadcrumbs />
                </div>
                <div>
                    <div>
                        <h2>Antes de subir</h2>                        
                        <ul>
                            <li>Medicamento para el mareo
                                <ul>
                                    <li>Dramamina / dimenhidrinato: tómalo 30–60 min antes.</li>
                                    <li>Meclizina (si la consigues): dura más y da menos sueño.</li>
                                </ul>
                                <label><i>No esperes a sentirte mal.</i></label>
                            </li>
                            <li>Come ligero: algo seco (galletas, pan, arroz).
                                <ul>
                                    <li>Evita grasas, alcohol y café.</li>
                                </ul>
                            </li>
                            <li>Descansa bien la noche anterior.</li>
                        </ul>
                    </div>
                    <div>
                        <h2>Durante el viaje</h2>                        
                        <ul>
                            <li>No uses el celular ni leas si ya te sientes mal.</li>
                            <li>Respira profundo y lento.</li>
                            <li>Mantén la cabeza apoyada y el cuerpo relajado.</li>
                            <li>Sal a cubierta si hay aire fresco (muchas personas mejoran ahí).</li>
                        </ul>
                    </div>

                    <div>
                        <h2>Si te empiezas a sentir muy mal</h2>                        
                        <ul>
                            <li>Mantente hidratado, pequeños sorbos de agua.</li>  
                            <li>Nuestros buques cuentan con un médico a bordo que se encuentra disponible para situaciones de emergencia.</li>                          
                        </ul>
                    </div>
                </div>

                <div className='temas-relacionados'>
                    <hr />

                    <h3>Temas relacionados</h3>
                    <ul>
                        
                        <li><Link to='/viajas-con-moto'>¿Viajas con moto?</Link></li>
                        <li><Link to='/viajar-con-menores-de-edad'>Viajar con menores de edad</Link></li>
                        <li><Link to='/viajar-con-mascotas'>Requisitos para viajar con mascotas</Link></li>                            
                    </ul>

                </div>
            </div>
            <Footer />
        </section>
    )
}
